import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@icon/triangle_right.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "My Projects", -1)
const _hoisted_2 = { class: "project-label" }
const _hoisted_3 = { class: "team-label" }
const _hoisted_4 = { class: "team-label__text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseSubHeading = _resolveComponent("BaseSubHeading")!
  const _component_icon = _resolveComponent("icon")!
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_SprintLabel = _resolveComponent("SprintLabel")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_MyWorkTripleDropdownTooltip = _resolveComponent("MyWorkTripleDropdownTooltip")!

  return (_openBlock(), _createBlock(_component_MyWorkTripleDropdownTooltip, {
    projects: _ctx.menu,
    rootMenuClass: "breadcrumb-root-menu",
    secondMenuClass: "breadcrumb-second-menu",
    thirdMenuClass: "breadcrumb-third-menu"
  }, {
    label: _withCtx(() => [
      _createVNode(_component_BaseSubHeading, {
        size: "large",
        weight: "400",
        color: "monochrome-05",
        className: "header__breadcrumb"
      }, {
        default: _withCtx(() => [
          _createTextVNode(" /"),
          _hoisted_1
        ]),
        _: 1
      })
    ]),
    project: _withCtx(({ project }) => [
      _createVNode(_component_BaseSubHeading, {
        class: "breadcrumb-menu-item",
        size: "large",
        weight: "400",
        color: "monochrome-07"
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_2, _toDisplayString(project.label), 1),
          _createVNode(_component_icon, {
            width: "6px",
            height: "8px",
            data: _imports_0,
            fill: "false",
            color: _ctx.iconColor,
            class: "selection__arrow"
          }, null, 8, ["color"])
        ]),
        _: 2
      }, 1024)
    ]),
    team: _withCtx(({ team }) => [
      _createVNode(_component_BaseSubHeading, {
        class: "breadcrumb-menu-item breadcrumb-menu-item-team",
        size: "large",
        weight: "400",
        color: "monochrome-07"
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_3, [
            _createVNode(_component_Avatar, {
              src: team.icon,
              size: "sm"
            }, null, 8, ["src"]),
            _createElementVNode("span", _hoisted_4, _toDisplayString(team.label), 1)
          ]),
          _createVNode(_component_icon, {
            width: "6px",
            height: "8px",
            data: _imports_0,
            fill: "false",
            color: _ctx.iconColor,
            class: "selection__arrow"
          }, null, 8, ["color"])
        ]),
        _: 2
      }, 1024)
    ]),
    sprint: _withCtx(({ sprints }) => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sprints, (sprint) => {
        return (_openBlock(), _createElementBlock(_Fragment, {
          key: sprint.id
        }, [
          (sprint.route)
            ? (_openBlock(), _createBlock(_component_RouterLink, {
                key: 0,
                to: sprint.route,
                class: "breadcrumb-menu-item breadcrumb-menu-item__sprint"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_SprintLabel, { sprint: sprint }, null, 8, ["sprint"])
                ]),
                _: 2
              }, 1032, ["to"]))
            : _createCommentVNode("", true)
        ], 64))
      }), 128))
    ]),
    _: 1
  }, 8, ["projects"]))
}